import styled from "styled-components";

export const StyledWipDetalhesPage = styled.section`
width: 100%;
overflow: hidden;
background-color: #F9F9F9;
padding-top: 2rem;
padding-bottom: 2rem;
padding-left: 1.5rem;
padding-right: 1.5rem;

.hover {
    &:hover {
        cursor: pointer;
    }
}

.default-button-red {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}

.default-button {
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: white;
    color: #EE4B21;
    font-size: 0.8rem;
}

.page-title {
    font-size: 24px;
    font-weight: bold;
    margin: -20px 0 13px 0;
}

.card {
    background-color: #fff;
    border-radius: .25rem;
    min-width: 90%;
    margin-top: 1rem;
    margin: 0;

    & .border-wrapper {
        border: solid 1px #ccc;
        border-radius: .25rem;
        padding: 1rem;
    }
}

.timesheet {
    .table-scroll {
        overflow-x: scroll;

    }

    .table.table-bordered > thead > tr > th,
    table.table-bordered > tbody > tr > td {
        white-space: nowrap;
        border-top-style: solid;
        border-left-style: solid;
        border-right-style: solid;
    }

    .table-container {
        overflow-x: auto;
        width: 100%;
        overflow-y: auto;
        height: calc(100vh - 195px);
    }
    .table-container table {
        margin: 0;
    }

    .legend-value {
        color: green;
        font-weight: 1000;
    }

    .legend {
        color: green;
    }

    .table.table-bordered > thead > tr {
        box-shadow: inset 0 1px 0 #E8E8E8, inset 0 -1px 0 #E8E8E8;
    }

   .width-30 {
        width: 30px;
    }

    .width-35 {
        width: 35px;
    }

    .width-40 {
        width: 40px;
    }

    .width-45 {
        width: 45px;
    }

    .width-50 {
        width: 50px;
    }

    .width-55 {
        width: 55px;
    }

    .width-60 {
        width: 60px;
    }

    .width-70 {
        width: 70px;
    }

    .width-80 {
        width: 80px;
    }

     .width-90 {
        width: 90px;
    }

    .width-96 {
        width: 96px;
    }

    .width-100 {
        width: 100px;
    }


    .width-110 {
        width: 110px;
    }


    .width-116 {
        width: 116px;
    }

    .width-150 {
        width: 148px;
    }

    .width-170 {
        width: 170px;
    }


    .width-180 {
        width: 180px;
    }


    .width-190 {
        width: 190px;
    }

    .table.table-bordered > thead {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
    }

    table.table-bordered > tfoot {
        background-color: #fff;
        position: -webkit-sticky;
        position: sticky;
        bottom: 0;
    }

    table.table-bordered > tfoot > tr > td {
        white-space: nowrap;
        border-top-style: solid;
        border-left-style: solid;
        border-right-style: solid;
        font-size: 12px;
        text-align: right;
        font-weight: 1000;
    }

}
`;
